// LLM generated - Model Claude 4 Sonnet

import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  dialogBody: {
    padding: '0 !important', // Force override Mantine's default padding
    // Apply responsive width constraints to the dialog body instead of modal
    [theme.fn.largerThan('sm')]: {
      minWidth: 500,
      maxWidth: 600,
      width: '90%',
      margin: '0 auto',
      padding: '0 !important', // Force override Mantine's default padding
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._32, // 32px gap between sections as per Figma
    overflow: 'auto',
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '0 16px 32px 16px', // Reduced padding for mobile
    maxHeight: '70vh',
    // Use larger padding on desktop
    [theme.fn.largerThan('sm')]: {
      padding: /* eslint-disable-line local-rules/use-theme-tokens */ '0 24px 32px 24px',
    },
    a: {
      color: theme.colors.blue[7],
      textDecoration: 'none',
    },
  },
  header: {
    padding: `${theme.other.spacing._16}px ${theme.other.spacing._16}px 0 ${theme.other.spacing._16}px`, // Reduced padding for mobile
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16,
    paddingBottom: theme.other.spacing._32, // Add 32px bottom padding for gap after PromoCard
    // Use larger padding on desktop
    [theme.fn.largerThan('sm')]: {
      padding: `${theme.other.spacing._16}px ${theme.other.spacing._24}px 0 ${theme.other.spacing._24}px`,
      paddingBottom: theme.other.spacing._32, // Ensure 32px bottom padding is preserved on desktop
    },
  },
  headerTitle: {
    textAlign: 'center',
    color: theme.colors.gray2[7],
  },
  promoCardContainer: {
    padding: 0,
    paddingTop: theme.other.spacing._12,
    width: '100%',
    maxWidth: '100%',
    overflow: 'visible',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'flex-start',
    [theme.fn.smallerThan('sm')]: {
      maxWidth: 390,
    },
    [theme.fn.largerThan('sm')]: {
      backgroundColor: theme.colors.gray2[0],
      borderRadius: theme.other.spacing._16,
      padding: theme.other.spacing._12,
    },
  },
  body: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._16, // 16px gap between sections
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
  },
  sectionTitle: {
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '22px',
    color: theme.colors.gray2[7],
    textTransform: 'uppercase',
  },
  sectionContent: {
    fontSize: '12px',
    lineHeight: '18px',
    color: theme.colors.gray2[6],
  },
  tags: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.other.spacing._8,
    flexWrap: 'wrap',
    marginTop: `-${theme.other.spacing._16}px`, // Compensate for 32px gap to get 16px
  },
  pill: {
    display: 'flex',
    padding: `${theme.other.spacing._2}px ${theme.other.spacing._8}px`,
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.other.spacing._4,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ '50px',
    background: theme.colors.gray2[0],
    height: theme.other.spacing._24,
  },
  list: {
    margin: 0,
    paddingLeft: theme.other.spacing._16,
  },
}));
